import React from "react";
import { Spin } from "antd";
import { CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import {
  StyledDrawer,
  DrawerHeader,
  CloseButton,
  DrawerTitle,
  DrawerBody,
  FantasyNameTitle,
  ContractSubtitle,
  ContractValue,
  StatsList,
  StatsRow,
  StatsLabel,
  StatsValue,
  DrawerFooter,
  PaginationGroup,
  PaginationButton,
  FooterActions,
  CancelButton,
  StartServiceButton,
} from "./styles";

const CREDENTIAL_STATS = [
  ["available", "available"],
  ["associated2", "associated"],
  ["withdrawals", "withdrawal"],
  ["printed_plural", "printed"],
  ["transferred_plural", "transferred"],
  ["total", "total"],
];

const CredentialStatsDrawer = ({
  open,
  onClose,
  fantasyname,
  contractNumber,
  credentialStats,
  loading,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  onStartService,
}) => {
  const intl = useIntl();

  return (
    <StyledDrawer
      open={open}
      onClose={onClose}
      placement="right"
      closable={false}
      title={null}
      footer={null}
      width={440}
      destroyOnClose
    >
      <DrawerHeader>
        <CloseButton
          type="button"
          onClick={onClose}
          aria-label={intl.formatMessage({ id: "close" })}
        >
          <CloseOutlined />
        </CloseButton>
        <DrawerTitle>
          {intl.formatMessage({ id: "contract_credentials_title" })}
        </DrawerTitle>
      </DrawerHeader>

      <DrawerBody>
        <FantasyNameTitle>{fantasyname}</FantasyNameTitle>
        <ContractSubtitle>
          {intl.formatMessage({ id: "contract" })}{" "}
          <ContractValue>{contractNumber}</ContractValue>
        </ContractSubtitle>

        {loading ? (
          <StatsList loading>
            <Spin />
          </StatsList>
        ) : (
          <StatsList>
            {CREDENTIAL_STATS.map(([labelId, statKey], index) => {
              const isTotal = index === CREDENTIAL_STATS.length - 1;

              return (
                <StatsRow total={isTotal} key={labelId}>
                  <StatsLabel>{intl.formatMessage({ id: labelId })}</StatsLabel>
                  <StatsValue total={isTotal}>
                    {credentialStats?.[statKey] || 0}
                  </StatsValue>
                </StatsRow>
              );
            })}
          </StatsList>
        )}
      </DrawerBody>

      <DrawerFooter>
        <PaginationGroup>
          <PaginationButton
            type="button"
            onClick={onPrevious}
            disabled={!hasPrevious}
            aria-label={intl.formatMessage({ id: "previous" })}
          >
            <LeftOutlined />
          </PaginationButton>
          <PaginationButton
            type="button"
            onClick={onNext}
            disabled={!hasNext}
            aria-label={intl.formatMessage({ id: "next" })}
          >
            <RightOutlined />
          </PaginationButton>
        </PaginationGroup>

        <FooterActions>
          <CancelButton type="button" onClick={onClose}>
            {intl.formatMessage({ id: "cancel" })}
          </CancelButton>
          <StartServiceButton type="button" onClick={onStartService}>
            {intl.formatMessage({ id: "start_service" })}
          </StartServiceButton>
        </FooterActions>
      </DrawerFooter>
    </StyledDrawer>
  );
};

export default CredentialStatsDrawer;
